import React from 'react';
import { Outlet } from 'react-router-dom';
import BreadcrumbsProvider from '../../contexts/Breadcrumbs';
import PrerequisitesProvider from '../../contexts/Prerequisites';

const MainLayout = () => {		
	return (
		<PrerequisitesProvider>
			<BreadcrumbsProvider>
				<Outlet />
			</BreadcrumbsProvider>
		</PrerequisitesProvider>
	);
};
export default MainLayout;